import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined } from '@ant-design/icons';

const { Footer } = Layout;
const { Link } = Typography;

const DashboardFooter: React.FC = () => {
  return (
    <Footer style={{ 
      textAlign: 'center',
      background: 'transparent',
      padding: '16px 50px'
    }}>
      <Space split={<span style={{ margin: '0 8px' }}>|</span>}>
        <span>Safe EMI Solutions ©{new Date().getFullYear()}</span>
        {/* <Link href="/dashboard/help">Help</Link>
        <Link href="/dashboard/privacy">Privacy</Link>
        <Link href="/dashboard/terms">Terms</Link>
        <Link href="https://github.com/your-repo" target="_blank">
          <Space>
            <GithubOutlined />
            <span>GitHub</span>
          </Space>
        </Link> */}
      </Space>
    </Footer>
  );
};

export default DashboardFooter;